import { useSelector } from 'react-redux';

import { useFeatureFlag } from './useFeatureFlag';
import { jsonStringToObject } from '../utils/common';
import { isSupportOrAdminUser } from '../utils/user';
import { SUPPLIER } from '../constants/roles';

export function useFeatureFlagPermissionsByRole({
  featureFlag,
  role = SUPPLIER,
  checkAdmin = true,
  checkEnabled = false,
}) {
  const { user: currentUser, supplierId: currentSupplierId } = useSelector((state) => state.role);
  const { retailer_id: currentRetailerId } = useSelector((state) => state.retailer.current);
  const roleId = role === SUPPLIER ? currentSupplierId : currentRetailerId;

  const isEnabled = useFeatureFlag(featureFlag, false, true);
  const allowedRoleIdsFromFeatureFlag = useFeatureFlag(featureFlag, JSON.stringify([]));
  const parsedRoles = jsonStringToObject(allowedRoleIdsFromFeatureFlag, []) || [];

  const isAllEnabled = checkEnabled && isEnabled;
  const isCymbioUser = checkAdmin ? isSupportOrAdminUser(currentUser?.role) : false;
  const isEnabledByRole = parsedRoles.includes(roleId);

  return { isEnabled: isAllEnabled || isCymbioUser || isEnabledByRole };
}
